import { apis, serviceInterface } from "./config";

export const getEvents = id => {
  return serviceInterface.get(`${apis.EVENT}${id ? "/" + id : ""}`);
};
